/**
 * `/code-review/agents` — *Default Coding Agents* section.
 * Wired to the `installation_settings.coding_agents` +
 * `installation_settings.default_coding_agent` columns added by
 * migration `007_coding_agents_and_status_checks.sql` (Phase 13).
 */
import { SettingsForm } from '../../components/SettingsForm.js';

export default function CodeReviewAgents() {
  return (
    <main className="feluda-settings">
      <SettingsForm
        section="agents"
        title="Default Coding Agents"
        subtitle="Pick which CLI agents Feluda may invoke, and which one is the active default."
      />
    </main>
  );
}
